import { COMMENT_ID_ATTRIBUTE, commentMarkSelector } from './anchor/grammar';

const unwrap = (mark: Element): void => {
    mark.replaceWith(...Array.from(mark.childNodes));
};

export const stripCommentMarks = (html: string): string => {
    const template = document.createElement('template');
    template.innerHTML = html;
    for (const mark of Array.from(template.content.querySelectorAll(commentMarkSelector()))) {
        unwrap(mark);
    }
    return template.innerHTML;
};

export const stripCommentMarkById = (html: string, commentId: string): string => {
    const template = document.createElement('template');
    template.innerHTML = html;
    for (const mark of Array.from(template.content.querySelectorAll(commentMarkSelector()))) {
        if (mark.getAttribute(COMMENT_ID_ATTRIBUTE) === commentId) {
            unwrap(mark);
        }
    }
    return template.innerHTML;
};
